// extracted by mini-css-extract-plugin
export default {"container":"DialogAlert_container__2lEtk","section":"DialogAlert_section__CP1o-","buttons":"DialogAlert_buttons__MyCjU","divider":"DialogAlert_divider__kMq5N"};